import { ProjectAddress as ProjectAddressDto, ProjectSummaryDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Container, Grid, Typography } from '@mui/material';
import { ProjectAddress } from '../../../../core/util/render-project-address';
import { useProjectSummaryContentStyles } from './project-summary-content.styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export interface ProjectSummaryContentProps {
  data?: {
    title?: string;
    projectType?: string;
    address?: ProjectAddressDto;
    summary?: ProjectSummaryDto;
  };
  isLoading?: boolean;
  errorMessage?: string;
}

export function ProjectSummaryContent(props: ProjectSummaryContentProps) {
  const classes = useProjectSummaryContentStyles();
  return (
    <Container className={classes.root}>
      <Grid container spacing={2} sx={{ flexDirection: 'column' }}>
        <Grid>
          <Typography variant="h6">{props.data?.title}</Typography>
          {props.data?.projectType && (
            <Typography color="textSecondary" variant="body1">
              {props.data.projectType}
            </Typography>
          )}
        </Grid>
        {props.data?.address && (
          <Grid>
            <ProjectAddress address={props.data.address} />
          </Grid>
        )}
        {(props.data?.summary?.rows ?? []).map((item) => (
          <Grid key={item.key}>
            <Typography variant="h6">{item.key}</Typography>
            <RenderValue value={item.value} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

function RenderValue({ value }: { value: string | number | boolean | null }) {
  if (!value) {
    return (
      <Typography variant="body1" color="textSecondary">
        N/A
      </Typography>
    );
  }

  if (typeof value === 'string' && value.startsWith('https://')) {
    return (
      <Typography variant="body1">
        <a href={value} target="_blank" rel="noopener noreferrer">
          Click to view{' '}
          <OpenInNewIcon
            style={{
              fontSize: '12px',
              marginBottom: '1px'
            }}
          />
        </a>
      </Typography>
    );
  }

  return <Typography variant="body1">{value}</Typography>;
}
